import { render, staticRenderFns } from "./CustomSelectItems.vue?vue&type=template&id=5ef5ce08"
import script from "./CustomSelectItems.vue?vue&type=script&lang=js"
export * from "./CustomSelectItems.vue?vue&type=script&lang=js"
import style0 from "./CustomSelectItems.vue?vue&type=style&index=0&id=5ef5ce08&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports